import React, { Component } from "react";

class Tab extends Component {
  // Helper function to determine active navigation link style
  getNavLinkStyle = (tab) => {
    const { activeTab } = this.props;
    const baseStyle = {
      textDecoration: 'none',
      cursor: 'pointer',
      paddingBottom: '4px',
      transition: 'all 0.2s ease',
        outline: 'none',
  boxShadow: 'none',
    };

    if (activeTab === tab) {
      return {
        ...baseStyle,
        color: '#333333',
        borderBottom: '3px solid #6E2D90',
        fontWeight: '600',
      };
    } else {
      return {
        ...baseStyle,
        color: '#4c526c',
        borderBottom: '2px solid transparent',
      };
    }
  };

  // Handle hover styles with JavaScript (since inline styles don't support :hover)
  handleMouseEnter = (e, tab) => {
    const { activeTab } = this.props;
    if (activeTab !== tab) {
      e.target.style.color = '#000000';
    }
  };

  handleMouseLeave = (e, tab) => {
    const { activeTab } = this.props;
    if (activeTab !== tab) {
      e.target.style.color = '#4c526c';
    }
  };

  // Convert mt prop to valid marginTop value
  getMarginTop = () => {
    const { mt } = this.props;
    if (mt) {
      if (typeof mt === 'number') return `${mt}px`;
      if (typeof mt === 'string') return mt;
    }
    return '12px'; // mt-3 equivalent (12px)
  };

  // Check if tabs array has items
  hasTabs = () => {
    const { tabs } = this.props;
    return tabs && tabs.length > 0;
  };

  render() {
    const { 
      tabs = [], 
      activeTab, 
      onTabChange, 
      showBorder, 
      mt, 
      isNowrap = false, 
      isTransparentBg 
    } = this.props;

    return (
      <div
        style={{
          overflow: 'hidden',
          borderBottom: showBorder ? '1px solid #eeeeee' : 'none',
        }}
      >
        {/* Navbar */}
        <div
          style={{
            fontSize: '14px',
            marginTop: this.getMarginTop(),
          }}
        >
          <nav
            style={{
              backgroundColor: !isTransparentBg ? 'white' : 'transparent',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                overflowX: 'auto',
                scrollbarWidth: 'none', // Firefox
                msOverflowStyle: 'none', // IE/Edge
              }}
              className="no-scrollbar" // Keep class for any additional CSS needed
            >
              <div
                style={{
                  display: 'flex',
                  gap: '24px',
                  flexWrap: isNowrap ? 'nowrap' : 'wrap',
                  whiteSpace: isNowrap ? 'nowrap' : 'normal',
                }}
              >
                {this.hasTabs() && tabs.map((tab) => {
                  // Safely check if tab has name and label properties
                  const hasName = Object.prototype.hasOwnProperty.call(tab, 'name');
                  const hasLabel = Object.prototype.hasOwnProperty.call(tab, 'label');
                  
                  if (!hasName || !hasLabel) return null;
                  
                  return (
                    <a
                      key={tab.name}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        onTabChange(tab.name);
                      }}
                      style={this.getNavLinkStyle(tab.name)}
                      onMouseEnter={(e) => this.handleMouseEnter(e, tab.name)}
                      onMouseLeave={(e) => this.handleMouseLeave(e, tab.name)}
                        onFocus={(e) => {
    e.target.style.outline = 'none';
    e.target.style.boxShadow = 'none';
  }}
                    >
                      {tab.label}
                    </a>
                  );
                })}
              </div>
            </div>
          </nav>
        </div>

        {/* Add global styles for scrollbar hiding if needed */}
        <style jsx>{`
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>
    );
  }
}

export default Tab;